export default {
  sm: `
  Our data with today's values
  is the future asset we have to
  protect with our own technology.
  `,
  md: `
  Our data with today's values
  is the future asset we have to protect
  with our own technology.
  `
};
